<!-- Modal.svelte -->
<script>
    import { getMobileOS } from "@/utils/common";

    let {
        isModalOpen = false,
        title,
        buttonAccept = null,
        buttonCancel = null,
        centered,
        className,
        cancelable = true,
        onClose,
        onAccept,
        content,
        infoButton,
        showButtons = false,
        disabledAccept = false,
    } = $props();

    function closeModal(mode) {
        onClose(mode);
    }
</script>

<!-- svelte-ignore a11y_consider_explicit_label -->
<!-- svelte-ignore element_invalid_self_closing_tag -->
{#if isModalOpen}
    <div class="modal {centered ? '--center' : ''} {className} {getMobileOS()}">
        <div class="modal__content">
            <div class="modal__header">
                {#if cancelable}
                    <div class="modal__close">
                        <button onclick={() => closeModal("back")}
                            ><i
                                class="icon fal {centered
                                    ? 'fa-times'
                                    : 'fa-arrow-left'}"
                            /></button
                        >
                    </div>
                {/if}
                {#if title}
                    <h2>{title}</h2>
                {/if}
            </div>
            {#if content}
                {@render content()}
            {/if}

            {#if showButtons}
                <div class="modal__buttons">
                    {@render infoButton()}
                    {#if buttonCancel}
                        <button
                            class="--cancel"
                            onclick={() => closeModal("button")}
                            >{buttonCancel}</button
                        >
                    {/if}

                    {#if buttonAccept}
                        <button
                            class="--black {disabledAccept ? '--disabled' : ''}"
                            onclick={onAccept}>{buttonAccept}</button
                        >
                    {/if}
                </div>
            {/if}
        </div>

        <div class="modal__overlay" onclick={closeModal}></div>
    </div>
{/if}

<style lang="scss">
    @use "./styles/index.scss";
</style>
